import { render } from "./StatusIndicators.vue?vue&type=template&id=623089cc"
import script from "./StatusIndicators.vue?vue&type=script&lang=js"
export * from "./StatusIndicators.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__